<template>
    <div>
      <div class="row settings-tabs full-height-tabs">
        <div class="col-lg-12 col-md-12">
          <vue-tabs
            ref="tabs"
            direction="vertical"
            class="row dispatch-tabs full-height-tabs items-align-dispatch-tabs text-align-dispatch-tabs"
            value="Description"
            @tab-change="handleTabChange"
          >

            <!-- PUSH NOTIFICATION CAMPAIGNS -->
            <v-tab :title="$t('pages.pushCampaigns')" class="text-left">
              <keep-alive>

                <module-locked
                  v-if="isCampaigns && !company.use_marketing_standard"
                  module="marketing"
                  icon="📢"
                  :title="$t('general.modules_marketing_title')"
                  :message="$t('general.modules_marketing_message')"
                  :hint="$t('general.modules_marketing_hint')"
                />

                <campaigns
                  v-if="isCampaigns && company.use_marketing_standard"
                  :isCampaigns="isCampaigns"
                />

              </keep-alive>
            </v-tab>
            <!-- COUPONS -->
            <v-tab :title="$t('pages.coupons')" class="text-left">
              <keep-alive>

                <module-locked
                  v-if="isCoupons && !company.use_marketing_standard"
                  module="marketing"
                  icon="🎟️"
                  :title="$t('general.modules_marketing_title')"
                  :message="$t('general.modules_marketing_message')"
                  :hint="$t('general.modules_marketing_hint')"
                />

                <discount-coupons
                  v-if="isCoupons && company.use_marketing_standard"
                />

              </keep-alive>
            </v-tab>
            <!-- SUBSCRIPTIONS -->
            <v-tab :title="$t('pages.subscriptions')" class="text-left">
              <keep-alive>

                <module-locked
                  v-if="isSubscriptions && !company.use_marketing_standard"
                  module="marketing"
                  icon="🎫"
                  :title="$t('general.modules_marketing_title')"
                  :message="$t('general.modules_marketing_message')"
                  :hint="$t('general.modules_marketing_hint')"
                />

                <subscriptions
                  v-if="isSubscriptions && company.use_marketing_standard"
                />

              </keep-alive>
            </v-tab>
            <!-- MENU SUBSCRIPTIONS (Abonamente meniuri) -->
            <v-tab :title="$t('pages.menuSubscriptions')" class="text-left">
              <keep-alive>

                <module-locked
                  v-if="isMenuSubscriptions && !company.use_marketing_standard"
                  module="marketing"
                  icon="🍱"
                  :title="$t('general.modules_marketing_title')"
                  :message="$t('general.modules_marketing_message')"
                  :hint="$t('general.modules_marketing_hint')"
                />

                <menu-subscriptions
                  v-if="isMenuSubscriptions && company.use_marketing_standard"
                />

              </keep-alive>
            </v-tab>
            <!-- AUTOMATIC MARKETING (birthday...) -->
            <v-tab :title="$t('pages.automationMarketing')" class="text-left">
              <keep-alive>

                <module-locked
                  v-if="isAutomation && !company.use_marketing_standard"
                  module="marketing"
                  icon="🤖"
                  :title="$t('general.modules_marketing_title')"
                  :message="$t('general.modules_marketing_message')"
                  :hint="$t('general.modules_marketing_hint')"
                />

                <automation-campaigns
                  v-if="isAutomation && company.use_marketing_standard"
                />

              </keep-alive>
            </v-tab>
            <v-tab :title="$t('pages.donationCampaigns')" class="text-left">
              <donation-campaigns v-if="isDonationCampaigns" :isDonationCampaigns="isDonationCampaigns"></donation-campaigns>
            </v-tab>
            <v-tab :title="$t('pages.discountCampaigns')" class="text-left">
              <keep-alive>
                <module-locked
                  v-if="isDiscountCampaigns && !company.use_marketing_standard"
                  module="marketing"
                  icon="🏷️"
                  :title="$t('general.modules_marketing_title')"
                  :message="$t('general.modules_marketing_message')"
                  :hint="$t('general.modules_marketing_hint')"
                />
                <discount-campaigns
                  v-if="isDiscountCampaigns && company.use_marketing_standard"
                  :isDiscountCampaigns="isDiscountCampaigns"
                />
              </keep-alive>
            </v-tab>
            <v-tab :title="$t('pages.challengeCampaigns')" class="text-left">
              <challenge-campaigns v-if="isChallengeCampaigns" :isChallengeCampaigns="isChallengeCampaigns"></challenge-campaigns>
            </v-tab>
            <v-tab :title="$t('pages.spinningWheelCampaigns')" class="text-left">
              <spinning-wheel-campaigns v-if="isSpinningWheelCampaigns" :isSpinningWheelCampaigns="isSpinningWheelCampaigns"></spinning-wheel-campaigns>
            </v-tab>
            <v-tab :title="$t('pages.referralCampaigns')" class="text-left">
              <referral-campaigns v-if="isReferralCampaigns" :isReferralCampaigns="isReferralCampaigns"></referral-campaigns>
            </v-tab>
            <v-tab :title="$t('pages.raffleCampaigns')" class="text-left">
              <raffle-campaigns v-if="isRaffleCampaigns" :isRaffleCampaigns="isRaffleCampaigns"></raffle-campaigns>
            </v-tab>
            <v-tab :title="$t('pages.loyaltyStoreCampaigns')" class="text-left">
              <loyalty-store-campaigns v-if="isLoyaltyStoreCampaigns" :isLoyaltyStoreCampaigns="isLoyaltyStoreCampaigns"></loyalty-store-campaigns>
            </v-tab>
            <v-tab :title="$t('pages.ambassadorRequests')" class="text-left">
              <referral-ambassador-requests v-if="isAmbassadorRequests" :isAmbassadorRequests="isAmbassadorRequests"></referral-ambassador-requests>
            </v-tab>
            <v-tab :title="$t('pages.offersSlider')" class="text-left">
              <keep-alive>

                <module-locked
                  v-if="isOffersSlider && !company.use_marketing_standard"
                  module="marketing"
                  icon="📢"
                  :title="$t('general.modules_marketing_title')"
                  :message="$t('general.modules_marketing_message')"
                  :hint="$t('general.modules_marketing_hint')"
                />

                <offers
                  v-if="isOffersSlider && company.use_marketing_standard"
                  :isOffersSlider="isOffersSlider"
                />

              </keep-alive>
            </v-tab>


            <!-- MENUS -->
            <v-tab :title="$t('pages.menus')" class="text-left">
              <keep-alive>

                <module-locked
                  v-if="isMenus && !company.use_marketing_standard"
                  module="marketing"
                  icon="📢"
                  :title="$t('general.modules_marketing_title')"
                  :message="$t('general.modules_marketing_message')"
                  :hint="$t('general.modules_marketing_hint')"
                />

                <dynamic-menu
                  v-if="isMenus && company.use_marketing_standard"
                  :isMenus="isMenus"
                />

              </keep-alive>
            </v-tab>
           <!-- LOYALITY -->
            <v-tab :title="$t('marketingFidelities.loyalityPoint')" class="text-left">
              <keep-alive>

                <module-locked
                  v-if="isLoyality && !company.use_marketing_standard"
                  module="marketing"
                  icon="🎯"
                  :title="$t('general.modules_marketing_title')"
                  :message="$t('general.modules_marketing_message')"
                  :hint="$t('general.modules_marketing_hint')"
                />

                <loyality
                  v-if="isLoyality && company.use_marketing_standard"
                  :isLoyality="isLoyality"
                />

              </keep-alive>
            </v-tab>

            <!-- USER LABELING -->
            <v-tab :title="$t('marketingFidelities.userLabeling')" class="text-left">
              <keep-alive>

                <module-locked
                  v-if="isUserLabeling && !company.use_marketing_standard"
                  module="marketing"
                  icon="🏷️"
                  :title="$t('general.modules_marketing_title')"
                  :message="$t('general.modules_marketing_message')"
                  :hint="$t('general.modules_marketing_hint')"
                />

                <UserLabeling
                  v-if="isUserLabeling && company.use_marketing_standard"
                  :isUserLabeling="isUserLabeling"
                />

              </keep-alive>
            </v-tab>

            <!-- PROMOS -->
            <v-tab :title="$t('pages.promos')" class="text-left">
              <keep-alive>

                <module-locked
                  v-if="isPromos && !company.use_marketing_standard"
                  module="marketing"
                  icon="📢"
                  :title="$t('general.modules_marketing_title')"
                  :message="$t('general.modules_marketing_message')"
                  :hint="$t('general.modules_marketing_hint')"
                />

                <promos
                  v-if="isPromos && company.use_marketing_standard"
                  :isPromos="isPromos"
                />

              </keep-alive>
            </v-tab>


            <!-- CUSTOMERS GROUPS -->
            <v-tab :title="$t('pages.customersGroups')" class="text-left">
              <keep-alive>

                <module-locked
                  v-if="isCustomersGroups && !company.use_marketing_standard"
                  module="marketing"
                  icon="📢"
                  :title="$t('general.modules_marketing_title')"
                  :message="$t('general.modules_marketing_message')"
                  :hint="$t('general.modules_marketing_hint')"
                />

                <groups-customer
                  v-if="isCustomersGroups && company.use_marketing_standard"
                  :isCustomersGroups="isCustomersGroups"
                />

              </keep-alive>
            </v-tab>


            <!-- APPROVALS -->
            <v-tab :title="$t('pages.approvals')" class="text-left">
              <keep-alive>

                <module-locked
                  v-if="isApprovals && !company.use_marketing_standard"
                  module="marketing"
                  icon="📢"
                  :title="$t('general.modules_marketing_title')"
                  :message="$t('general.modules_marketing_message')"
                  :hint="$t('general.modules_marketing_hint')"
                />

                <approvals
                  v-if="isApprovals && company.use_marketing_standard"
                  :isApprovals="isApprovals"
                />

              </keep-alive>
            </v-tab>
            <v-tab :title="$t('pages.giftCard')" class="text-left">
              <keep-alive>

                <module-locked
                  v-if="isGiftCard && !company.use_marketing_gift_card"
                  module="gift_card"
                  icon="🎁"
                  :title="$t('general.modules_gift_card_title')"
                  :message="$t('general.modules_gift_card_message')"
                  :hint="$t('general.modules_gift_card_hint')"
                />

                <gift-card
                  v-if="isGiftCard && company.use_marketing_gift_card"
                />

              </keep-alive>
            </v-tab>
            <v-tab :title="$t('pages.scanner')" class="text-left">
              <keep-alive>

                <!-- <module-locked
                  v-if="isScanner && !company.use_marketing_loyalty_points_scanner"
                  module="loyalty_points_scanner"
                  icon="🎁"
                  :title="$t('general.modules_gift_card_title')"
                  :message="$t('general.modules_gift_card_message')"
                  :hint="$t('general.modules_gift_card_hint')"
                /> -->

                <scanner
                  v-if="isScanner"
                />

              </keep-alive>
            </v-tab>
          </vue-tabs>
        </div>
      </div>
    </div>
</template>

  <script>
  import Campaigns from 'src/components/Dashboard/Views/Marketing/Campaigns/Campaigns.vue'
  import DiscountCoupons from 'src/components/Dashboard/Views/Marketing/DiscountCoupons/Coupons.vue'
  import Subscriptions from 'src/components/Dashboard/Views/Marketing/Subscriptions/Subscriptions.vue'
  import MenuSubscriptions from 'src/components/Dashboard/Views/Marketing/MenuSubscriptions/MenuSubscriptions.vue'
  import AutomationCampaigns from 'src/components/Dashboard/Views/Marketing/AutomationCampaigns/AutomationCampaigns.vue'
  import DonationCampaigns from 'src/components/Dashboard/Views/Marketing/DonationCampaigns/DonationCampaigns.vue'
  import DiscountCampaigns from 'src/components/Dashboard/Views/Marketing/DiscountCampaigns/DiscountCampaigns.vue'
  import ChallengeCampaigns from 'src/components/Dashboard/Views/Marketing/ChallengeCampaigns/ChallengeCampaigns.vue'
  import SpinningWheelCampaigns from 'src/components/Dashboard/Views/Marketing/SpinningWheel/SpinningWheelCampaigns.vue'
  import ReferralCampaigns from 'src/components/Dashboard/Views/Marketing/Referral/ReferralCampaigns.vue'
  import RaffleCampaigns from 'src/components/Dashboard/Views/Marketing/RaffleCampaigns/RaffleCampaigns.vue'
  import LoyaltyStoreCampaigns from 'src/components/Dashboard/Views/Marketing/LoyaltyStore/LoyaltyStoreCampaigns.vue'
  import ReferralAmbassadorRequests from 'src/components/Dashboard/Views/Marketing/Referral/ReferralAmbassadorRequests.vue'
  import Offers from 'src/components/Dashboard/Views/Marketing/Offers/Offers.vue'
  import DynamicMenu from 'src/components/Dashboard/Views/Marketing/DynamicMenus/DynamicMenu.vue'
  // import Fidelities from 'src/components/Dashboard/Views/Marketing/Fidelities/Fidelities.vue'
  import Promos from 'src/components/Dashboard/Views/Marketing/Promos/Promos.vue'
  import GroupsCustomer from 'src/components/Dashboard/Views/Customers/Groups/Groups.vue'
  import Approvals from 'src/components/Dashboard/Views/Customers/Approvals/Approvals.vue'
  import GiftCard from 'src/components/Dashboard/Views/Marketing/GiftCard/GiftCard.vue'
  import Loyality from 'src/components/Dashboard/Views/Marketing/Fidelities/Loyality.vue'
  import UserLabeling from 'src/components/Dashboard/Views/Marketing/Fidelities/UserLabel/UserLabeling.vue'
  import Scanner from 'src/components/Dashboard/Views/LoyaltyPointsScanner/LoyaltyPointsScanner.vue'
  import ModuleLocked from '../../../UIComponents/ModuleLocked.vue'
  export default {
    components: {
      Campaigns,
      DiscountCoupons,
      Subscriptions,
      MenuSubscriptions,
      AutomationCampaigns,
      DonationCampaigns,
      DiscountCampaigns,
      ChallengeCampaigns,
      SpinningWheelCampaigns,
      ReferralCampaigns,
      RaffleCampaigns,
      LoyaltyStoreCampaigns,
      ReferralAmbassadorRequests,
      Offers,
      DynamicMenu,
      Loyality,
      UserLabeling,
      Promos,
      GroupsCustomer,
      Approvals,
      ModuleLocked,
      GiftCard,
      Scanner
    },
    data () {
      return {
        isCampaigns: false,
        isCoupons: false,
        isSubscriptions: false,
        isMenuSubscriptions: false,
        isAutomation: false,
        isDonationCampaigns: false,
        isDiscountCampaigns: false,
        isChallengeCampaigns: false,
        isSpinningWheelCampaigns: false,
        isReferralCampaigns: false,
        isRaffleCampaigns: false,
        isLoyaltyStoreCampaigns: false,
        isAmbassadorRequests: false,
        isOffersSlider: false,
        isMenus: false,
        isLoyality: false,
        isUserLabeling: false,
        isPromos: false,
        isCustomersGroups: false,
        isGiftCard: false,
        isApprovals: false,
        isScanner: false
      }
    },
    computed: {
      company () {
        return (this.userData && this.userData.companies && this.userData.companies[0]) || {}
      }
    },
    mounted () {
      this.userData = JSON.parse(this.$session.get('userData') || '{}')

      const index = this.$route.query.tabIndex
      if (index != null && index !== '') {
        this.switchTab()
      } else {
        this.isCampaigns = true
      }
    },
    watch: {
      '$route.query.tabIndex' () {
        this.switchTab()
      }
    },
    methods: {
      resetStates () {
        this.isCampaigns = false
        this.isCoupons = false
        this.isSubscriptions = false
        this.isMenuSubscriptions = false
        this.isAutomation = false
        this.isDonationCampaigns = false
        this.isDiscountCampaigns = false
        this.isChallengeCampaigns = false
        this.isSpinningWheelCampaigns = false
        this.isReferralCampaigns = false
        this.isRaffleCampaigns = false
        this.isLoyaltyStoreCampaigns = false
        this.isAmbassadorRequests = false
        this.isOffersSlider = false
        this.isMenus = false
        this.isLoyality = false
        this.isUserLabeling = false
        this.isPromos = false
        this.isCustomersGroups = false
        this.isApprovals = false
        this.isGiftCard = false
        this.isScanner = false
      },
      switchTab () {
        const index = this.$route.query.tabIndex
        this.$nextTick(() => {
          if (index != null && index !== '' && this.$refs.tabs) {
            const tabIndex = parseInt(index, 10)
            this.$refs.tabs.navigateToTab(tabIndex)
            this.activateTabByIndex(tabIndex)
          }
        })
      },
      activateTabByIndex (tabIndex) {
        this.resetStates()
        const tabFlags = [
          'isCampaigns',
          'isCoupons',
          'isSubscriptions',
          'isMenuSubscriptions',
          'isAutomation',
          'isDonationCampaigns',
          'isDiscountCampaigns',
          'isChallengeCampaigns',
          'isSpinningWheelCampaigns',
          'isReferralCampaigns',
          'isRaffleCampaigns',
          'isLoyaltyStoreCampaigns',
          'isAmbassadorRequests',
          'isOffersSlider',
          'isMenus',
          'isLoyality',
          'isUserLabeling',
          'isPromos',
          'isCustomersGroups',
          'isApprovals',
          'isGiftCard',
          'isScanner'
        ]
        const flag = tabFlags[tabIndex]
        if (flag) {
          this[flag] = true
        } else {
          this.isCampaigns = true
        }
      },
      handleTabChange (tabIndex) {
        this.$router.push(`${this.$route.path}?tabIndex=${tabIndex}`)
        this.activateTabByIndex(tabIndex)
      }
    }
  }
  </script>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Marketing/MarketingSidebar.vue